import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/warehouse-management/warehouse-circulation-report`;

export const warehouseCirculationReportRoutesObj = {
  list: baseRoute,
} as const;

export type IWarehouseCirculationReportRouteParams = IExtractRouteParamMap<
  typeof warehouseCirculationReportRoutesObj
>;

export const warehouseCirculationReportPath = createPaths<
  typeof warehouseCirculationReportRoutesObj,
  IWarehouseCirculationReportRouteParams
>(warehouseCirculationReportRoutesObj);
